import { useState } from 'react';
import { login } from '../offline/sync.js';

import { API_BASE } from '../config.js';

interface Props {
  /** Dipanggil selepas log masuk berjaya, bersama butiran yang boleh diisi semula. */
  onToken: (token: string, meta: { email: string; slug: string }) => void;
  reason?: string;
  /** E-mel dan pautan kedai yang diisi semula supaya pemilik tidak perlu menaipnya setiap kali. */
  initialEmail?: string | undefined;
  initialSlug?: string | undefined;
  /**
   * Jalan keluar apabila borang ini dibuka DARIPADA POS.
   *
   * Kasir yang tersilap menekan "Admin" mesti boleh kembali bekerja tanpa memuat semula halaman atau
   * menutup pelayar.
   */
  onCancel?: () => void;
}

/**
 * Log masuk semula tanpa menyentuh pairing.
 *
 * Sesi pemilik luput selepas 12 jam. Sebelum ini, satu-satunya cara untuk kembali ke back office
 * ialah "sediakan semula peranti" — yang memerlukan kod pairing baharu (sah 15 minit) dan
 * memadam identiti peranti. Itu tidak munasabah untuk kerja harian.
 *
 * Log masuk hanya menukar token; kunci peranti, katalog dan outbox tidak disentuh.
 */
export function LoginForm({
  onToken,
  reason,
  onCancel,
  initialEmail,
  initialSlug,
}: Props): React.ReactElement {
  const [shopSlug, setShopSlug] = useState(initialSlug ?? '');
  const [email, setEmail] = useState(initialEmail ?? '');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const session = await login(API_BASE, { email, password, shopSlug });
      onToken(session.token, { email, slug: shopSlug });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'log masuk gagal');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="setup">
      <h1>Log masuk</h1>
      <p className="muted">
        {reason ?? 'Sesi pemilik sudah luput.'} Peranti, katalog dan jualan yang belum dihantar tidak
        terjejas — hanya sesi baharu diperlukan.
      </p>

      <form onSubmit={submit}>
        <label>
          Pautan kedai
          <input
            value={shopSlug}
            onChange={(event) => setShopSlug(event.target.value)}
            placeholder="kedai-akuarium-72"
            required
          />
        </label>
        <label>
          E-mel
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <label>
          Kata laluan
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>

        {error !== null && <p className="error">{error}</p>}

        <button type="submit" disabled={busy}>
          {busy ? 'Memproses…' : 'Log masuk'}
        </button>
      </form>

      {onCancel !== undefined && (
        <button type="button" className="ghost" onClick={onCancel}>
          Kembali ke POS
        </button>
      )}
    </div>
  );
}
